export const colors = {
  background: '#222A5D',
  primary: '#213743',
  secondary: '#3d5564',
  text: '#F2F7FF',
  purple: '#E8159C',
  purpleDark: '#8D27B3'
} as const
